export default __webpack_public_path__ + "static/media/braking.da579285.svg";